import { HttpClientJsonpModule, HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { appRoutes } from "./app.routes";
import { PIMeoSharedModule } from "./setups/modules/shared";

export const imports = [
    BrowserModule,
    HttpClientModule,

    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, { scrollPositionRestoration: "enabled" }),

    HttpClientModule,
    HttpClientJsonpModule,

    PIMeoSharedModule,
];
